import { render, staticRenderFns } from "./MemoryField.vue?vue&type=template&id=5b9c4aab&lang=pug&"
import script from "./MemoryField.vue?vue&type=script&lang=js&"
export * from "./MemoryField.vue?vue&type=script&lang=js&"
import style0 from "./MemoryField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9c4aab')) {
      api.createRecord('5b9c4aab', component.options)
    } else {
      api.reload('5b9c4aab', component.options)
    }
    module.hot.accept("./MemoryField.vue?vue&type=template&id=5b9c4aab&lang=pug&", function () {
      api.rerender('5b9c4aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/MemoryField.vue"
export default component.exports